import gql from "graphql-tag";
// IMPORTANT: keep this query in its own file for optimal code chunking.
export const queryGlobalStylesheet = gql`
  query GlobalStylesheet {
    contentFragment(group: "stylesheets", key: "global") {
      text
    }
  }
`;
